export default {
    titulo: "Clientes",
    nuevo: "Nuevo cliente",
    buscar: "Buscar por nombre, documento, celular o correo electrónico",
    eliminar: "Eliminar cliente",
    pregEliminar: "¿Confirmas que deseas eliminar el cliente?",
    editar: "Editar cliente",
    nombre: "Nombre del cliente", 
    email: "Correo electrónico",
    clave: "Clave de acceso",
    personaContacto: "Persona contacto",
    emailAlt: "Correo electrónico alternativo",
    telefono: "Teléfono",
    celular: "Celular",
    documento: "Documento",
    direccion: "Dirección",
    pais: "País",
    depto: "Departamento/Provincia/Estado",
    localidad: "Localidad",
    sucursalPreferida: "Sucursal preferida",
    textCodigoPais: "Indica el código de país al principio",
    codManual: "Código manual",
    activo: "Activo",
    encuesta: "Enviar encuesta",
    director: "Director/Responsable",
    razon: "Razón social",
    giro: "Giro",
    contactoAdmin: "Contacto de administración",
    telefonoAdmin: "Teléfono de administración",
    buscarEquipo: "Buscar por descripción, tipo de equipo, marca o modelo",
    eliminarEquipo: "Eliminar equipo asociado al cliente",
    pregEliminarEquipo: "¿Confirmas que deseas eliminar equipo asociado al cliente?",
    pregSucursal: "¿Deseas asociar el equipo a una sucursal del cliente?",
    msgEquipoAsociado: "El equipo ya se encuentra asociado al cliente",
    sucursales: "Sucursales del cliente",
    eliminarSuc: "Eliminar sucursal del cliente",
    pregEliminarSuc: "¿Confirmas que deseas eliminar la sucursal del cliente?",
    msgErrorLimitePlan: "No se puede ingresar más clientes porque excede el plan contratado"
}